import AvenirNextBold from '@fonts/AvenirNext/AvenirNext-Bold.otf';
import AvenirNextMedium from '@fonts/AvenirNext/AvenirNext-Medium.otf';
import AvenirNextRegular from '@fonts/AvenirNext/AvenirNext-Regular.otf';

export const components = {
    MuiButtonBase: {
        defaultProps: {
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                borderRadius: '3rem',
            },
        },
    },
    MuiCssBaseline: {
        styleOverrides: `
@font-face {
    font-family: 'Avenir Next';
     src: local('AvenirNext'), local('AvenirNext-Regular'), url(${AvenirNextRegular}) format('opentype');
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'Avenir Next';
     src: local('AvenirNext'), local('AvenirNext-Medium'), url(${AvenirNextMedium}) format('opentype');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: 'Avenir Next';
    font-weight: 700;
    font-style: normal;
    src: local('AvenirNext'), local('AvenirNext-Bold'), url(${AvenirNextBold}) format('opentype');
}
        `,
    },
    MuiButton: {
        defaultProps: {
            disableElevation: true,
        },
        variants: [
            {
                props: {variant: 'contained', color: 'neutral'},
                style: {
                    backgroundColor: 'palette.neutral.800',
                    color: '#fff',
                    '&:hover': {
                        backgroundColor: 'palette.neutral.900',
                    },
                },
            },
            {
                props: {variant: 'soft', color: 'neutral'},
                style: {
                    backgroundColor: 'palette.neutral.200',
                    color: 'palette.neutral.800',
                    '&:hover': {
                        backgroundColor: 'palette.neutral.300',
                    },
                },
            },
        ],
        styleOverrides: {
            root: ({theme}) => ({
                fontSize: '1rem',
                borderRadius: '2rem',
                '&:focus-visible': {
                    outline: `2px solid ${theme.palette.primary.main}`,
                    outlineOffset: 0,
                },
            }),
            sizeLarge: {
                minHeight: '3rem',
            },
        },
    },
    MuiDialogTitle: {
        styleOverrides: {
            root: ({theme}) => ({
                padding: '1.5rem 2rem',
            }),
        },
    },
    MuiDialogContent: {
        styleOverrides: {
            root: ({theme}) => ({
                padding: '0 2rem',
            }),
        },
    },
    MuiCard: {
        styleOverrides: {
            root: () => ({
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }),
        },
    },
    MuiDialogActions: {
        styleOverrides: {
            root: ({theme}) => ({
                padding: '1.5rem 2rem',
            }),
        },
    },
    MuiFormLabel: {
        styleOverrides: {
            root: ({theme}) => ({
                display: 'block',
                flex: '0 0 auto',
                fontSize: '.9rem',
                fontWeight: '700',
                color: theme.palette.neutral[600],
                '&.Mui-focused': {
                    color: theme.palette.neutral[600],
                },
                '&.Mui-error': {
                    color: theme.palette.neutral[600],
                },
                [theme.breakpoints.up('lg')]: {
                    fontSize: '1rem',
                },
            }),
        },
    },
    MuiGrid: {
        styleOverrides: {
            root: ({theme}) => ({
                flexGrow: 1,
            }),
        },
    },
    MuiInputBase: {
        styleOverrides: {
            root: {
                '& input:autofill, & input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active, & textarea:autofill, & textarea:-webkit-autofill, & textarea:-webkit-autofill:hover, & textarea:-webkit-autofill:focus, & textarea:-webkit-autofill:active, & select:autofill, & select:-webkit-autofill, & select:-webkit-autofill:hover, & select:-webkit-autofill:focus, & select:-webkit-autofill:active':
                    {
                        filter: 'none',
                        WebkitBoxShadow: '0 0 0px 1000px transparent inset !important',
                        transition: 'background-color 5000s ease-in-out 0s !important',
                    },
                '& input:-internal-autofill-selected, & input:-internal-autofill-selected:hover, & input:-internal-autofill-selected:focus, & input:-internal-autofill-selected:active, & textarea:-internal-autofill-selected, & textarea:-internal-autofill-selected:hover, & textarea:-internal-autofill-selected:focus, & textarea:-internal-autofill-selected:active, & select:-internal-autofill-selected, & select:-internal-autofill-selected:hover, & select:-internal-autofill-selected:focus, & select:-internal-autofill-selected:active':
                    {
                        filter: 'none',
                        WebkitBoxShadow: '0 0 0px 1000px transparent inset !important',
                        transition: 'background-color 5000s ease-in-out 0s !important',
                    },
            },
        },
    },
    MuiSwitch: {
        styleOverrides: {
            root: {
                width: 42,
                height: 26,
                padding: 0,
            },
            switchBase: ({theme}) => ({
                padding: 0,
                margin: 2,
                '&.Mui-checked': {
                    transform: 'translateX(16px)',
                    color: '#fff',
                    '& + .MuiSwitch-track': {
                        backgroundColor:
                            theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.primary.light,
                        opacity: 1,
                        border: 0,
                    },
                    '&.Mui-disabled + .MuiSwitch-track': {
                        opacity: 0.5,
                        backgroundColor:
                            theme.palette.mode === 'light' ? theme.palette.neutral[700] : theme.palette.neutral[400],
                    },
                },
                '&.Mui-focusVisible .MuiSwitch-thumb': {
                    border: '2px solid ' + theme.palette.primary.main,
                },
                '&.Mui-disabled .MuiSwitch-thumb': {
                    color: theme.palette.mode === 'light' ? theme.palette.neutral[300] : theme.palette.neutral[600],
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: theme.palette.mode === 'light' ? 0.7 : 0.5,
                },
            }),
            thumb: {
                boxSizing: 'border-box',
                width: 22,
                height: 22,
            },
            track: ({theme}) => ({
                borderRadius: 26 / 2,
                backgroundColor:
                    theme.palette.mode === 'light' ? theme.palette.neutral[300] : theme.palette.neutral[600],
                opacity: 1,
                transition: theme.transitions.create(['background-color'], {
                    duration: 300,
                }),
            }),
        },
    },
};
